<div class="container">

  <div class="modal-header">
    <p class="title">{{ data?.title }}</p>
    <div class="icon-container">
      <ion-icon name="close" color="primary" role="button" tabindex="0" (click)="data?.closeButtonCallback()"
        (keydown.enter)="data?.closeButtonCallback()" class="i-close" aria-label="Cerrar"></ion-icon>
    </div>
  </div>

  <p class="subtitle">{{ data?.subtitle }}</p>

</div>

<div class="button-container">
  <button class="b-btn s-button" (click)="data?.primaryButtonCallback()">
    {{ data?.primaryButtonText }}
  </button>

  <button class="b-btn p-button" (click)="data?.secondaryButtonCallback()">
    {{ data?.secondaryButtonText }}
  </button>
</div>